import { scrollSmootherInstance } from "../globals/gsap";

class TopLink {
  constructor($el) {
    this.$el = $el;
    this.init();
  }

  init = () => {
    this.$el.on('click', this.onClick);
  }

  onClick = (e) => {
    e.preventDefault();
    
    // scroll to top
    scrollSmootherInstance.scrollTo(0,true);
  }
}

export default TopLink;